import React, { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify';


const ToastMessage = () => {
    
    return (
        <div>
            <ToastContainer position="top-center" hideProgressBar />
        </div>
    )
}

export default ToastMessage